import React from "react";
import { Link } from "react-router-dom";
import Reveal from "./Reveal";

export default function CtaSection({
  eyebrow = "Get started",
  title = "Ready to Secure Your Financial Future?",
  description = "Contact our team of experts to discuss your investment goals and discover tailored solutions for your wealth.",
  ctaLabel = "Get in touch",
  ctaTo = "/contact",
  testId = "cta-section",
}) {
  return (
    <section data-testid={testId} className="relative py-24 sm:py-32 bg-[#0B1120] border-y border-white/5">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 lg:px-12 text-center">
        <Reveal>
          <div className="text-[11px] tracking-[0.32em] uppercase text-[#D4AF37]">{eyebrow}</div>
        </Reveal>
        <Reveal delay={120}>
          <h2 className="mt-6 font-serif-display text-white text-4xl sm:text-5xl leading-tight tracking-tight">
            {title}
          </h2>
        </Reveal>
        <Reveal delay={240}>
          <p className="mt-6 max-w-2xl mx-auto text-white/70 text-base sm:text-lg font-light leading-relaxed">
            {description}
          </p>
        </Reveal>
        <Reveal delay={360}>
          <Link
            to={ctaTo}
            data-testid={`${testId}-cta-button`}
            className="mt-10 inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.32em] bg-[#D4AF37] text-[#070B14] px-8 py-4 hover:bg-[#F3CE52] transition-colors duration-300"
          >
            {ctaLabel}
            <span aria-hidden="true">→</span>
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
